<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Kontakt" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div>
			<form-grid-layout>
				<div v-show="active == 'details'">
					<string-view label="Navn" v-model="entity.name" />
					<string-view :optional="true" label="Telefon" v-model="entity.phone" />
					<string-view :optional="true" label="Fax" v-model="entity.fax" />
					<string-view :optional="true" label="E-mail" v-model="entity.email" />
				</div>
				<div v-show="active == 'details'">
					<text-view :optional="true" label="Detaljer" v-model="entity.details" :height="150" />
				</div>
				<div v-show="active == 'details'">
					<text-view :optional="true" label="Info" v-model="entity.info" :height="150" />
				</div>
				<div v-show="active == 'details' && false">
					<text-view :optional="true" label="Blacklisted" v-model="entity.blacklisted" :height="150" />
				</div>
				<address-view v-show="active == 'address'" v-model="entity" :optional="['address', 'zip', 'city', 'country']" />
				<div v-for="(role, i) in roles" v-bind:key="'roles' + i" v-show="active == 'roles'">
					<div class="side-window__heading">
						{{ role.label }}
						<switch-view v-model="entity.roles[role.name].enabled" />
					</div>
					<component v-for="(prop, j) in role.props" :optional="true" v-bind:key="j" :is="prop.type" :label="prop.label" v-model="entity.roles[role.name][prop.name]" v-show="entity.roles[role.name].enabled" />
				</div>
				<div v-show="active == 'invoicing'">
					<contact-select-view v-model="entity" label="Fakturering" :optional="true" altName="invoice_contact" />
				</div>
				<div v-show="active == 'invoicing'">
					<div class="side-window__heading">
						Send automatisk faktura fra Moovr
						<switch-view v-model="entity.email_invoice" />
					</div>
				</div>
				<div v-show="active == 'invoicing'">
					<text-view :optional="true" label="Fast tekst på faktura" v-model="entity.invoice_text" :height="200" />
				</div>
				<div v-for="(num, i) in entity.numbers" v-bind:key="'number' + i" v-show="active == 'invoicing'">
					<div class="side-window__heading">
						{{ num.label }}
						<icon-button-view icon="close" @click="removeNumber(i)" />
					</div>
					<div class="side-window__heading small">
						Samme nummer på hver ordre
						<switch-view v-model="entity.numbers[i].static" />
					</div>
					<string-view v-show="entity.numbers[i].static" :optional="true" label="Nummer" v-model="entity.numbers[i].value" />
				</div>
				<div v-show="active == 'invoicing'">
					<div style="cursor: pointer;" class="side-window__heading" @click="addNumber">Tilføj referencenummer</div>
				</div>
				<div v-show="active == 'pack'">
					<div class="side-window__heading">
						Ubegrænset udlån
						<switch-view v-model="entity.pack_unlimited" />
					</div>
					<text-view :optional="true" label="Bemærkninger" v-model="entity.pack_remarks" :height="100" />
				</div>
				<div class="status" v-show="active == 'pack'">
					<div class="side-window__heading">Status</div>
					<div v-for="(s, i) in pack.status" :key="i" class="item">
						<div class="title">{{ s.label }}</div>
						<div class="qty">{{ s.qty }}</div>
					</div>
				</div>
				<div class="hist" v-show="active == 'pack'">
					<div class="btn" @click="register">Ny registrering</div>
					<div class="btn" @click="pickup">Opret afhentning</div>
					<div class="btn" @click="waive">Eftergiv alt</div>
					<div class="side-window__heading">Historik</div>
					<div class="item" v-for="(a, i) in pack.history" :key="i">
						<div class="action">{{ a.label }}</div>
						<div class="date">{{ a.date | date }}</div>
						<div class="employee">{{ a.employee }}</div>
						<div class="products">
							<div class="item" v-for="(p, j) in a.products" :key="j">
								<div class="title">{{ p.label }}</div>
								<div class="qty">{{ p.qty }}</div>								
							</div>
						</div>
						<img class="pack-signature" v-if="a.signature" :src="a.signature" style="display:block;max-width:220px;margin-top:8px;background:#fff;border-radius:4px;" />
					</div>
				</div>
				<div class="prices-view" v-show="active == 'prices'">
					<div class="header">
						<div>Produkt</div>
						<div>Pris</div>
						<div></div>
					</div>
					<div v-for="(p, i) in entity._embedded.prices" :key="i" class="row">
						<div><select-view :simple="true" :options="_products" v-model="p.product_id" /></div>
						<div><simple-number-view :optional="true" v-model="p.price" /></div>
						<div class="btn" @click="removePrice(i)" style="text-align: right;">X</div>
					</div>
					<div class="btn" @click="addPrice()">Tilføj pris</div>
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="submit(entity)" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import AddressView from '../views/AddressView';
	import ContactSelectView from '../views/ContactSelectView';
	import PackWindow from '../windows/PackWindow';

	import ContactModel from '../model/Contact';
	import merge from '../functions/merge';

	import CourierTaskModel from '../model/CourierTask'
	import CourierTaskWindow from '../windows/CourierTaskWindow'

	import { bus } from '../../bus'

	export default {
		data: function () {
			return {
				entity: {},
				active: 'details',
				roles: [],
				products: [],
				pack: {
					status: [],
					history: []
				}
			};
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'AddressView': AddressView,
			'ContactSelectView': ContactSelectView
		},
		computed: {
			_products() {
				var r = [];

				for (var i = 0; i < this.products.length; ++i) {
					var p = this.products[i];

					r.push({
						label: p.label,
						value: p.id
					});
				}

				return r;
			},
			_roles() {
				var r = {};
				var role;
				var props;
				var prop;

				for (var i = 0; i < this.roles.length; ++i) {
					role = this.roles[i];
					props = {};
					
					for (var j = 0; j < role.props.length; ++j) {
						prop = role.props[j];
						props[prop.name] = prop.default;
					}

					r[role.name] = {
						enabled: false,
						props: props
					};
				}

				return r;
			},
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'address',
						label: 'Adresse'
					},
					{
						name: 'roles',
						label: 'Roller'
					},
					{
						name: 'invoicing',
						label: 'Fakturering'
					},
					{
						name: 'pack',
						label: 'Emballage'
					},
					{
						name: 'prices',
						label: 'Priser'
					},
				];
			}
		},
		props: {
			submit: {
				type: Function,
				default: function () {}
			},
			initActive: {
				type: String,
				default: 'details'
			},
			value: {
				type: Object,
				default() {
					return merge.assign({}, ContactModel);
				}
			}
		},
		methods: {
			addPrice() {
				this.entity._embedded.prices.push({
					product_id: null,
					price: ''
				});
			},
			removePrice(i) {
				this.entity._embedded.prices.splice(i, 1);
			},
			addNumber() {
				var label;

				if (label = prompt('Label')) {
					this.entity.numbers.push({
						label: label,
						value: '',
						static: true
					});
				}
			},
			removeNumber(i) {
				this.entity.numbers.splice(i, 1);
			},			
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			input(name, value) {
				this.entity[name] = value;
			},
			update() {
				var self = this;

				if (this.entity.id) {
					this.axios
						.get('/contacts/' + this.entity.id + '/pack/status/')
						.then(function (r) {
							self.pack.status = r.data;
						});

					this.axios
						.get('/contacts/' + this.entity.id + '/pack/history/')
						.then(function (r) {
							self.pack.history = r.data;
						});
				}
			},
			register() {
				
				var self = this;

				this.$store.state.windowStack.push(PackWindow, {
					async submit(action, products) {
						
						self.$store.state.windowStack.pop();
						
						// Update
						this.axios
							.post('/contacts/' + self.entity.id + '/pack/' + action + '/', {
								products: products
							})
							.then(function (r) {
								self.update();
								bus.$emit('update');
							});
					}
				});
			},
			waive() {
				var self = this;

				// Calculate how much
				var r = {};

				for (var i = 0; i < this.pack.status.length; ++i) {
					if (this.pack.status[i].qty != 0) {
						r[this.pack.status[i].id] = this.pack.status[i].qty;
					}
				}

				if (Object.keys(r).length == 0) {
					alert('Der er intet at eftergive');
					return;
				}

				if (!confirm('Er du sikker på at du vil eftergive alt?')) return;
				
				

				this.axios
					.post('/contacts/' + self.entity.id + '/pack/waive/', {
						products: r
					})
					.then(function (r) {
						self.update();
						bus.$emit('update');
					});
			},
			pickup() {
				var self = this;
				var ent = CourierTaskModel.entity();
				ent.type				= 'pickup';
				ent.employee_id 		= self.$store.state.employee.id;
				ent.department_id 		= self.$store.state.employee.department_id;
				ent._embedded.employee	= self.$store.state.employee;

				ent.contact_id 			= self.entity.id;
				ent._embedded.contact	= self.entity;

				ent.details.packaging = {};

				for (var i = 0; i < this.pack.status.length; ++i) {
					if (this.pack.status[i].qty != 0) {
						ent.details.packaging[this.pack.status[i].id] = this.pack.status[i].qty;
					}
				}


				self.$store.state.windowStack.push(CourierTaskWindow, {
					value: ent,
					lookup: true,
					async submit(entity) {
						if (await CourierTaskModel.save(self.axios, entity)) {
							self.$store.state.windowStack.pop();
							self.update();
							bus.$emit('update');
						}
					}
				});
			}
		},
		mounted: async function() {
			
			

			var self = this;

			this.entity = merge({}, this.value);

			this.active = this.initActive;

			this.products = (await this.axios.get('/products/')).data._items;

			

			this.axios
				.get('/contacts/roles/')
				.then(function (r) {
					self.roles = r.data._items;
					self.entity.roles = {...self._roles, ...self.entity.roles};
				});

			self.update();
		}
	}
</script>

<style lang="scss">
	.contact {
		& .prices-view {
			& > .header, & > .row {
				display: grid;
				grid-template-columns: 2fr 1fr 20px;

				& > div {
					line-height: 20px;
					font-size: 12px;
					text-align: left;
					padding-left: 5px;

					&.unit {
						text-align: left;
					}

					&.price, &.total, &.adjust, &.vat {
						text-align: left;
					}

					&.total {
						line-height: 30px;
					}

					&:first-child {
						text-align: left;
						padding-left: 0;
					}
				}

				& > .btn {
					background-color: transparent ! important;
					line-height: 30px;
					margin: 0;
				}
			}

			& > .header {
				& > div {
					font-weight: bold;
				}
			}

			& > .row {
				& > div.sum-title {
					line-height: 30px;
					text-align: left;
				}

				& > div.line {
					border-top: 1px solid white;
					padding-top: 5px;
				}

				& > div {
					& > input {
						width: 100%;
					
						text-align: left;
						background-color: #202127;
						color: white;
						line-height: 20px;
						font-size: 12px;
						padding: 5px;
					}

					&.unit > input {
						text-align: left;
					}

					&.price > input, &.adjust > input, &.vat > input {
						text-align: right;
					}

					&.label {
						width: 100%;

						&::v-deep .entity-select-view {
							height: 100%;

							& > input {
								font-size: 12px;
							}
						}
					}
				}
			}			
		}

		& .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}

		& .status {
			& > .item {
				display: grid;
				grid-template-columns: 1fr 1fr;

				& > .qty {
					text-align: right;
				}
			}
		}

		& .hist {
			& > .item {
				padding: 20px;
				border: 1px solid #2d2f36;
				margin-bottom: 20px;
				display: grid;
				grid-template-columns: 1fr 1fr;

				& > .employee {
					grid-column: 1 / 3;
				}

				& > .date {
					text-align: right;
				}

				& > .products {
					grid-column: 1 / 3;
					
					& > .item {
						margin-top: 10px;
						display: grid;
						grid-template-columns: 1fr 1fr;

						& > .qty {
							text-align: right;
						}
					}
				}
			}
		}
	}
</style>
